export default __webpack_public_path__ + "static/media/acido_2.72d1d899.jpg";